const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgBinoculars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5C10.5 17.433 8.933 19 7 19C5.067 19 3.5 17.433 3.5 15.5C3.5 13.567 5.067 12 7 12C8.933 12 10.5 13.567 10.5 15.5ZM10.5 15.5V9M13.5 15.5V9M13.5 15.5C13.5 17.433 15.067 19 17 19C18.933 19 20.5 17.433 20.5 15.5C20.5 13.567 18.933 12 17 12C15.067 12 13.5 13.567 13.5 15.5ZM6 12.1449L9.5 8M18 12.1449L14.5 8M15 8.5L14.5 7.37499C14.5 6.875 13.5 6.875 13.5 7.37499V9.37501M9 8.50008L9.5 7.3699C9.5 6.8699 10.5 6.8698 10.5 7.36996C10.5 7.87012 10.5 9.37517 10.5 9.37517",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.575aa0dbc51ded4081c5938edf3a2b51.svg";
export { ForwardRef as ReactComponent };